import { useQuery } from "react-query";
import type { UseQueryOptions } from "react-query";

import { internalApi } from "@/react/helpers/urlHelpers";

import type { ApiError } from "../config/CustomErrors";

export const usePlanFeatureFlags = (
  reactQueryOptions: Omit<
    UseQueryOptions<unknown, ApiError, unknown, string[]>,
    "queryKey"
  > = {},
) =>
  useQuery({
    queryKey: [internalApi.planFeatureFlags.show()],
    ...reactQueryOptions,
  });
